import React from 'react';
import { Skeleton } from '@welbe/web-design-system';

import {
	ContainerCard,
	SkeletonTextContainer,
	WrapperLoading,
} from './Campaigns.styles';
import { Card } from './components/Card/Card';

export const CampaignsSkeleton = (): JSX.Element => {
	return (
		<WrapperLoading>
			<SkeletonTextContainer loading={true}>
				<Skeleton width="42%" borderRadius="13px" height="28px" />
			</SkeletonTextContainer>
			<SkeletonTextContainer className="subtitle">
				<Skeleton width="55%" borderRadius="6px" height="16px" />
			</SkeletonTextContainer>
			<ContainerCard hasMargin>
				{[1, 2, 3].map((campaign: any) => (
					<Card key={campaign} loading={true} />
				))}
			</ContainerCard>
		</WrapperLoading>
	);
};
